import { useBus, useListener } from "react-bus";
import { DeleteUserNotificationModalProps } from "./types";
import { useCallback, useContext, useState } from "react";
import { AppContext } from "../../../../Contexts/AppContext";
import { Box, Button, CircularProgress, Modal } from "@mui/material";
import UserNotificationApi from "../../../../api/user-notification";
import { isAxiosError } from "axios";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	textAlign: "center",
	p: 4,
};

export default function DeleteUserNotificationModal(
	props: DeleteUserNotificationModalProps
) {
	const { userNotificationToDelete } = props;
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const bus = useBus();

	const handleOpen = useCallback(() => setOpen(true), []);
	const handleClose = () => setOpen(false);
	const { snackBar, setSnackBar } = useContext(AppContext);

	useListener("openDeleteUserNotificationModal", handleOpen);

	const deleteOperation = useCallback(async () => {
		if (!userNotificationToDelete) return;
		try {
			setLoading(true);
			await UserNotificationApi.delete({
				accessToken: localStorage.getItem("accessToken") || "",
				id: userNotificationToDelete._id,
			});
			bus.emit("reloadUserNotifications");
			handleClose();
			setSnackBar({
				...snackBar,
				open: true,
				message: "Notificacion eliminada",
				autoHideDuration: 6000,
				severity: "success",
			});
		} catch (error: any) {
			console.error(error);
			let errMsg = "Error al eliminar la notificacion";
			if (isAxiosError(error)) {
				errMsg = error.response?.data?.message || errMsg;
			}
			setSnackBar({
				...snackBar,
				open: true,
				message: errMsg,
				autoHideDuration: 6000,
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}, [userNotificationToDelete]);
	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				<h2 id='modal-modal-title'>
					{loading ? "Eliminando Notificacion" : "Eliminar Notificacion"}
				</h2>
				{loading ? (
					<CircularProgress size={35} />
				) : (
					<>
						<p id='modal-modal-description'>
							Esta seguro que desea eliminar la notificacion para{" "}
							{userNotificationToDelete?.email} ?
						</p>

						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								marginTop: 2,
							}}>
							<Button
								variant='contained'
								color='error'
								onClick={() => {
									deleteOperation();
								}}>
								Eliminar
							</Button>
							<Button variant='contained' color='primary' onClick={handleClose}>
								Cancelar
							</Button>
						</Box>
					</>
				)}
			</Box>
		</Modal>
	);
}
